import { CodedError } from '../CodedError';
import { errorCodeTypes } from './errorCodeTypes';

export class FloorNameAlreadyExistsError extends CodedError {
  static get errorName() {
    return errorCodeTypes.floorNameAlreadyExistsError.code;
  }

  constructor(message = errorCodeTypes.floorNameAlreadyExistsError.message) {
    super(message);
    this.code = errorCodeTypes.floorNameAlreadyExistsError.code;
    this.message = `${message} ${errorCodeTypes.floorNameAlreadyExistsError.code}`;
    this.name = errorCodeTypes.floorNameAlreadyExistsError.name;
  }
}
